import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../../contexts';
import { ProfileResult } from '../../types/result';
import { RiasecDimension } from '../../types/quiz';

interface Props {
  result: ProfileResult;
}

const DIMENSION_COLORS: Record<RiasecDimension, string> = {
  R: 'bg-orange-400',
  I: 'bg-blue-500',
  A: 'bg-purple-500',
  S: 'bg-green-500',
  E: 'bg-red-500',
  C: 'bg-yellow-500',
};

const ScoreBar: React.FC<Props> = ({ result }) => {
  const { t } = useTranslation();
  const { isRTL } = useLanguage();
  const maxScore = 6;

  return (
    <div className="bg-white rounded-2xl shadow-sm p-5" dir={isRTL ? 'rtl' : 'ltr'}>
      <h3 className="text-sm font-bold text-gray-700 uppercase tracking-wide mb-4">
        {t('result.scores')}
      </h3>
      <div className="space-y-3">
        {(Object.entries(result.scores) as [RiasecDimension, number][]).map(([dim, score]) => (
          <div key={dim} className="flex items-center gap-3">
            <span className="w-24 text-xs font-semibold text-gray-600 shrink-0">
              {t(`result.dimensions.${dim}`)}
            </span>
            <div className="flex-1 bg-gray-100 rounded-full h-3">
              <div
                className={`${DIMENSION_COLORS[dim]} h-3 rounded-full transition-all duration-700`}
                style={{ width: `${(score / maxScore) * 100}%` }}
              />
            </div>
            <span className="w-6 text-xs font-bold text-gray-700 text-right shrink-0">
              {score}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ScoreBar;
